import { jsx as _jsx } from "react/jsx-runtime";
import { getEventById, loadEventById, LoadingState } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { useLoadAction } from '@vista-digital/react-tools';
import { observer } from 'mobx-react';
import { useCallback } from 'react';
import { withComponentWrapper } from '../../utils/with-component-wrapper';
import { EventContextMessage, EventContextMessageType } from './subcomponents/message';
import { EventContextInstance } from './types/context';
import { defaultEventContextProps, eventContextPropsValidator } from './types/props';
const b = bemClassBuilder('v-event-context');
const EventContext = observer(props => {
    const { eventId, displayText, assets } = props;
    const loadAction = useCallback(() => loadEventById(eventId), [eventId]);
    const { loadingState, reload } = useLoadAction(loadAction);
    if (loadingState === LoadingState.Failure) {
        return (_jsx(EventContextMessage, { messageType: EventContextMessageType.FailedToLoadData, displayText: displayText, assets: assets, onRetryButtonClick: reload }));
    }
    const event = getEventById(eventId);
    return (_jsx(EventContextInstance.Provider, Object.assign({ value: { event, eventId } }, { children: _jsx("div", Object.assign({ className: b.block({ loading: loadingState === LoadingState.Loading }) }, { children: props.children })) })));
});
EventContext.displayName = 'EventContext';
/**
 * The **Event Context** component loads an event from the API and provides it to its children via the `EventContextInstance`.
 *
 * It will render a single error message with a retry button if the event fails to load.
 */
export const EventContextComponent = withComponentWrapper(EventContext, defaultEventContextProps, eventContextPropsValidator);
